import { getQueryParams, mergeQueryParams, removeQueryParams } from "../../../../_common/queryParams";

/**
 * closes all mobile filters
 */
export function closeAllFilters(bpMax01) {
  const plpViewMenu = document.getElementById("plp-view-menu");
  const megaFilter = document.getElementById("plp-filters-base");

  const plpViewMenuShouldClose = plpViewMenu.querySelectorAll(".view-menu__descent-block");
  const megaFilterShouldClose = megaFilter.querySelectorAll(".view-menu__descent-block");
  const viewType = megaFilter.dataset.viewType;
  const eventNotification = new CustomEvent(`MenuCloseEvent`, { bubbles: true, detail: { viewType } });

  if (megaFilter !== undefined || megaFilter !== null) {
    megaFilter.classList.remove("active");
    document.body.classList.remove("overlay-active");
  }

  plpViewMenuShouldClose.forEach(shouldClose => {
    if (shouldClose !== null && shouldClose !== undefined) {
      shouldClose.classList.remove("active");
    }
  });

  megaFilterShouldClose.forEach(shouldClose => {
    if (shouldClose !== null && shouldClose !== undefined) {
      if (shouldClose.getAttribute("data-desktop-open") && !bpMax01.matches) {
        shouldClose.classList.add("active");
        return;
      }
      shouldClose.classList.remove("active");
    }
  });

  document.querySelector(".view-menu__top").classList.remove("active");
  document.getElementById("mobile-filter-apply-btn").classList.remove("active");
  plpViewMenu.dispatchEvent(eventNotification);
}

/**
   * showMobileFilters
   * event listener for
   */
export function showMobileFilters(e) {
  const showTop = document.querySelector(".view-menu__top");
  const showApply = document.getElementById("mobile-filter-apply-btn");
  const target = e.currentTarget;
  const showBlock = target.parentElement.querySelector(".view-menu__descent-block");
  const topText = showTop.querySelector(`.view-menu__top-title`);

  topText.innerText = target.innerText
    .split(` `)
    .map(t => `${t[0].toUpperCase()}${t.slice(1)}`)
    .join(` `);
  if (target.id === "plp-filters-switch") {
    const refineFilter = document.getElementById("plp-filters-base");

    if (refineFilter !== undefined || refineFilter !== undefined) {
      refineFilter.classList.add("active");
    }
  }
  document.body.classList.add("overlay-active");

  showTop.classList.add("active");
  showApply.classList.add("active");
  if (showBlock !== undefined && showBlock !== null) {
    showBlock.classList.add("active");
  }
}

/**
   * mobileViewMenuNext
   * event listener for
   */
export function mobileViewMenuNext(e) {
  const current = e.currentTarget;
  const nextBlock = current.parentElement.lastElementChild;

  nextBlock.classList.add("active");
}

export function mobileViewReset() {
  const activeDiv = document.querySelector(`.view-menu__descent-block--mobile-full-base.active`);
  const type = activeDiv.dataset.mobileSubMenuType;

  if (type === `VIEW_AS`) {
    activeDiv.querySelector(`[data-default-view]`).click();
  } else {
    const allQueries = getQueryParams(window);
    let path = ``;
    const { origin } = window.location;

    if (type === `REFINE`) {
      const filteredQuery = removeQueryParams(allQueries, [`mblFilter`, `generalFacets`]);
      path = `${origin}/search/?${mergeQueryParams(filteredQuery)}`;
    } else if (type === `SORT_BY`) {
      const searchQuery = removeQueryParams(allQueries, [`sortBy`, `sortDirection`]);
      const { pathname } = window.location;
      path = `${origin}${pathname}?${mergeQueryParams(searchQuery)}`;
    }

    window.location.replace(path);
  }
}



// WEBPACK FOOTER //
// ./javascript/product-search-page/raw-from-relab/plp-header/view/mobileView.js